"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdentityProviderV2Client = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("./authenticated.client");
class IdentityProviderV2Client extends authenticated_client_1.AuthenticatedClient {
    create(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const createIdentityProviderUrl = '/v2/idp';
            const response = yield this.httpPost(createIdentityProviderUrl, request, { throwOnError: true });
            return response.payload;
        });
    }
    update(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const createIdentityProviderUrl = `/v2/idp/${request.id}`;
            const { id } = request, body = tslib_1.__rest(request, ["id"]);
            const response = yield this.httpPut(createIdentityProviderUrl, body, { throwOnError: true });
            return response.payload;
        });
    }
    delete(id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const createIdentityProviderUrl = `/v2/idp/${id}`;
            const response = yield this.httpDelete(createIdentityProviderUrl);
            return response.payload;
        });
    }
    getById(id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const createIdentityProviderUrl = `/v2/idp/${id}`;
            const response = yield this.httpGet(createIdentityProviderUrl);
            return response.payload;
        });
    }
    getByAccountId(accountId, fields) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const queryString = fields && this.getQueryString(fields);
            const createIdentityProviderUrl = `/v2/idp/account/${accountId}?${queryString}`;
            const response = yield this.httpGet(createIdentityProviderUrl, { throwOnError: false });
            return response.payload;
        });
    }
}
exports.IdentityProviderV2Client = IdentityProviderV2Client;
//# sourceMappingURL=identity-provider.v2.client.js.map